// src/stores/global.ts
import { defineStore } from 'pinia'
import axios from 'axios'

export const useGlobalStore = defineStore('global', {
  state: () => ({
    userPermissions: [] as any[],
    Status: [] as any[],
  }),
  actions: {
    async fetchData() {
      try {
        const userDataStr = localStorage.getItem('userData')
        if (userDataStr && userDataStr !== 'undefined') {
          const userData = JSON.parse(userDataStr)

          const [permissionsResponse, countsResponse, statusResponse] = await Promise.all([
            axios.get(`/api/auth/get_perms_user/${userData.id}`),
            axios.get(`/api/auth/new_customers_count`),
            axios.get(`/api/auth/AllStatus`)
          ])

          this.userPermissions = permissionsResponse.data
          localStorage.setItem('newCstmrs', countsResponse.data.newCstmrs)
          localStorage.setItem('newLivs', countsResponse.data.newLivs)
          localStorage.setItem('newClaims', countsResponse.data.newClaims)
          localStorage.setItem('newPickup', countsResponse.data.newPickup)
          localStorage.setItem('newReturn', countsResponse.data.newReturn)
          localStorage.setItem('ribRequests', countsResponse.data.ribRequests)

          this.Status = statusResponse.data
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },
    globalHelper(s: string | undefined) {
      if (s && s !== 'undefined') {
        const found = this.Status.find(o => o.code === s)
        return found || ''
      }
      return ''
    }
  }
})
